import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-status',
  templateUrl: './button-status.component.html',
  styleUrls: ['./button-status.component.scss']
})
export class ButtonStatusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
